module.exports = __webpack_public_path__ + "img/no-history.1f614fca.png";